import { RANKINGS_TEMPLATE } from '../data/consts';

class LocalStorageService {
  constructor() {}

  static saveRankings(rankings) {
    localStorage.setItem('rankings', JSON.stringify(rankings));
    return rankings;
  }

  static loadRankings() {
    return (
      JSON.parse(localStorage.getItem('rankings')) ||
      this.saveRankings(RANKINGS_TEMPLATE)
    );
  }
}

export default LocalStorageService;
